import React from 'react'

const LocationMark = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.12504 9.27018C6.23615 9.27018 6.34032 9.25268 6.43754 9.21768C6.53476 9.18324 6.62504 9.12435 6.70837 9.04102L9.66671 6.08268C9.81948 5.9299 9.89587 5.73546 9.89587 5.49935C9.89587 5.26324 9.81948 5.06185 9.66671 4.89518C9.50004 4.7424 9.29865 4.66602 9.06254 4.66602C8.82643 4.66602 8.63198 4.7424 8.47921 4.89518L6.12504 7.24935L5.54171 6.66602C5.38893 6.51324 5.19449 6.43685 4.95837 6.43685C4.72226 6.43685 4.52782 6.51324 4.37504 6.66602C4.20837 6.83268 4.12504 7.03407 4.12504 7.27018C4.12504 7.50629 4.20837 7.70074 4.37504 7.85352L5.54171 9.04102C5.62504 9.12435 5.71532 9.18324 5.81254 9.21768C5.90976 9.25268 6.01393 9.27018 6.12504 9.27018ZM7.00004 16.5202C6.88893 16.5202 6.77782 16.4993 6.66671 16.4577C6.5556 16.416 6.45837 16.3605 6.37504 16.291C4.34726 14.4993 2.83337 12.8363 1.83337 11.3018C0.833374 9.76685 0.333374 8.33268 0.333374 6.99935C0.333374 4.91602 1.00365 3.25629 2.34421 2.02018C3.68421 0.784071 5.23615 0.166016 7.00004 0.166016C8.76393 0.166016 10.3159 0.784071 11.6559 2.02018C12.9964 3.25629 13.6667 4.91602 13.6667 6.99935C13.6667 8.33268 13.1667 9.76685 12.1667 11.3018C11.1667 12.8363 9.65282 14.4993 7.62504 16.291C7.54171 16.3605 7.44448 16.416 7.33337 16.4577C7.22226 16.4993 7.11115 16.5202 7.00004 16.5202Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default LocationMark
